import {
  Input,SimpleChanges,OnChanges,
  ViewChild,
  Component,
  OnInit,Inject
} from '@angular/core';
import {API_URL_FILE_UPLOAD}  from '../../../services/constants';
import { ActivatedRoute, Router } from '@angular/router';
import {MatDialogModule} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {TranslateService} from "../../../../../node_modules/ng2-translate/src/translate.service";
import {AlertService} from "../../../services/alert/alert.service";
import { FileUploader } from 'ng2-file-upload';



/**
 * A Sample of how simple it is to create a new window, with its own injects.
 */
@Component({
  selector: 'fr-file-upload',
  template: require('./file-upload.template.html'),
  styles: [require('./file-upload.style.css')]
})
export class FileUploadComponent {

  public textToCopy:string;
  uploader:FileUploader;
  response:string;

  constructor(public dialogRef:MatDialogRef<FileUploadComponent>,
              @Inject(MAT_DIALOG_DATA) public data:any,
              public route:ActivatedRoute,
              public alertService:AlertService,
              public router:Router,
              public dialog:MatDialog,
              private translate:TranslateService) {

    this.uploader = new FileUploader({url: API_URL_FILE_UPLOAD});
    this.response = '';
     let parent=this;
    this.uploader.response.subscribe( res =>
      {
        this.response = res;
        if(res){parent.uploadOK(res)}
        else { parent.uploadFailed(res)} } );

  }

  uploadOK(filename:string) {
    this.alertService.showSuccessMessage("بارگذاری فایل با موفقیت انجام شد.");
this.data.file_name=filename;
    this.dialogRef.close(this.data);
  }
  uploadFailed(error) {
    this.alertService.showErrorMessage("بارگذاری انجام نشد . نوع فایل و حجم فایل را بررسی کنید.");
    this.dialogRef.close();


  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/file-upload/file-upload.component.ts